import { FC } from 'react';

export const FilterIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14">
    <path
      d="M15 1H1l5.6 6.3v4.37L9.4 13V7.3z"
      stroke="currentColor"
      strokeWidth="1.29"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
